export default __webpack_public_path__ + "static/media/explore.64c6581d.jpg";